<div
  class="relative z-[1] -mt-[7rem] px-0 py-20 h-[520px] bg-[url('/images/hero.png')] dark:bg-[url('/images/dark-hero.png')] bg-center bg-cover bg-no-repeat clip-perfect-inverted-triangle">
  <div class="py-4 flex flex-col gap-4 text-center text-secondary mt-24 dark:text-white">
    <h1 class="text-2xl sm:text-5xl font-bold md:text-6xl">
      {{ "Home_Page.Hero_Title" | translate }}
    </h1>
    <p class="text-base sm:text-lg md:text-xl font-normal md:font-medium">
      {{ "Home_Page.Hero_Subtitle" | translate }}

      <br class="block md:hidden" />
      {{ "Home_Page.Hero_Subtitle_br" | translate }}
    </p>
  </div>
</div>

<div #homeSection class="search relative z-[4] -mt-[12rem] max-w-full mx-auto px-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
  <app-flight-search [label]="'search'" />
</div>

<div class="feature container max-w-full mx-auto px-4 text-center mt-[12px] py-3 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
  <div class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mt-[30px]">
    @for (card of featureCards; track card; let i = $index) {
    <div
      class="feature-card group flex h-[130px] px-4 py-6 flex-col items-center gap-2 flex-1 basis-0 grow rounded-2xl border-2 border-[#EAEAEA] transition-all duration-300">
      <div class="relative w-10 h-10">
        <img [src]="card.icon" [alt]="card.alt"
          class="absolute inset-0 w-full h-full opacity-100 group-hover:opacity-0 scale-100 group-hover:scale-105 transition-all duration-300 ease-in-out" />
        <img [src]="card.iconWithHover" [alt]="card.alt"
          class="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 transition-all duration-300 ease-in-out" />
      </div>
      <h3 class="text-third dark:text-white font-medium opacity-90 text-[20px]">
        {{ card.label | translate }}
      </h3>
    </div>
    }
  </div>
</div>

<div class="discover container max-w-full mx-auto px-4 text-center mt-[12px] py-3 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
  <h3 class="text-secondary dark:text-white font-medium text-[22px] md:text-[34px] py-2">
    {{ "Home_Page.Discover_Title" | translate }}
  </h3>
  <span class="md:text-base text-[12px] mt-[20px] text-third dark:text-white">
    {{ "Home_Page.Discover_Subtitle" | translate }}
  </span>
  <div class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-[30px]">
    @for (card of cards; track card; let i = $index) {
    <div
      class="bg-white dark:bg-primary-dark dark:border-white p-[24px] py-12 rounded-2xl shadow border-2 border-transparent hover:bg-[#FFFFFF8C] hover:border-[#86C3F1CC] dark:hover:bg-[#1E1E488C] transition-all duration-400">
      <div
        class="bg-light-blue rounded-full w-[62px] h-[62px] text-[28px] font-medium flex justify-center items-center m-auto text-brand">
        {{ i + 1 }}
      </div>
      <h3 class="py-2 mt-2 text-lg font-medium text-secondary dark:text-white">
        {{ card.title | translate }}
      </h3>
      <p class="text-third dark:text-white text-[15px]">
        {{ card.body | translate }}
      </p>
    </div>
    }
  </div>
</div>

<div class="marquee py-4 mt-[12px] overflow-hidden">
  <div class="mx-auto w-full max-w-screen-xl px-0">
    <div class="flex items-center gap-4 whitespace-nowrap animate-marquee">
      @for (text of marqueeTexts; track i; let i = $index) {
      <img src="/icons/plane-logo.svg" alt="plane-logo" class="w-10" />
      <h2 [ngClass]="text.color"
        class="text-[24px] font-medium font-serif tracking-wider leading-relaxed dark:text-white">
        {{ text.text | translate }}
      </h2>
      }
    </div>
  </div>
</div>

<div class="adventure relative overflow-hidden py-14 mt-[12px]">
  <div class="absolute inset-0 bg-gradient-to-b from-[#C4E2F8] to-[#EFF5FD] dark:from-[#29295C] dark:to-[#17223E] z-0">
  </div>

  <div
    class="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#86C3F1CC] to-[#FFFFFF00] dark:from-[#1E2D85] dark:to-[#37377D00] z-10">
  </div>

  <div class="relative z-20 flex flex-col items-center justify-center gap-4 text-center">
    <img class="hidden md:block w-50" [src]="isDark ? '/icons/white_Logo.svg' : '/icons/BlueLogo.svg'" alt="logo" />

    <h2 class="text-secondary dark:text-white sm:text-4xl md:text-[48px] font-medium">
      {{ "Home_Page.Adventure_Title" | translate }}
      <br />
      {{ "Home_Page.Trending_Locations" | translate }}
    </h2>

    <p class="text-third dark:text-white text-sm md:text-base w-80 md:w-150">
      {{ "Home_Page.Adventure_Subtitle" | translate }}
      <br />
    </p>

    <button (click)="scrollToTop()"
      class="bg-brand text-white px-4 md:px-20 py-4 text-xl rounded-2xl font-medium justify-center flex gap-2 items-center hover:bg-third dark:hover:bg-white hover:text-[#86C3F1] transition-all duration-300 group">
      <span class="flex gap-2 items-center transition-transform duration-300 group-hover:scale-[1.05]">
        {{ "Home_Page.Button_Book_Flight" | translate }}

        <svg xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 inline-block transition-opacity duration-300 group-hover:opacity-0" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg"
          class="w-8 h-8 inline-block absolute mt-1 rtl:left-0 ltr:right-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          viewBox="0 0 24 24" fill="currentColor">
          <path fill-rule="evenodd"
            d="M4.5 12a.75.75 0 0 1 .75-.75h11.19l-3.22-3.22a.75.75 0 1 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H5.25A.75.75 0 0 1 4.5 12Z"
            clip-rule="evenodd" />
        </svg>
      </span>
    </button>
  </div>
</div>